'use strict';

export default class OrderedItemsSearch {
	constructor(params) {
		this.root = document.querySelector(params.rootSelector);
	}

	init() {
		if (!this.root) return false;

		this.form = this.root.querySelector('form');
		this.input = this.root.querySelector('[data-product-items-search-input]');
		this.ajaxContainer = document.querySelector('[data-items-list]');
		this.sortAndDisplay = [...document.querySelectorAll('[data-url-search]')];
		this.resetBtn = this.root.querySelector('[data-reset-btn]');
		this.type = this.root.dataset.productItemsSearch;

		this.dirty = false;

		this._checkFormDirty();
		this._inputHandler();
		this._formsHandler();
		this._resetBtnHandler();

	}

	_formsHandler() {
		if (!this.form) return false;

		this.form.addEventListener('submit', e => {
			e.preventDefault();
			
			this._sendRequest();
		})
	}

	_sendRequest(url = this.form.action) {
		let data = {};

		let display = document.querySelector('[data-display].current');
		let sort = document.querySelector('[data-sort].current') || document.querySelector("[data-sort-dropdown] [data-sort-key].current");

		if (display) data.display = display.dataset.display;
		if (sort) {
			data.sort = sort.dataset.sort || sort.dataset.sortKey;
			data.order = sort.dataset.order|| sort.dataset.sortOrder;
		}

		data[this.input.name] = this.input.value;

		$.ajax({
			url: url,
			data: data,
			method: 'GET',
			dataType: 'json',
			beforeSend: () => {
				this.form.classList.add('is-loading');
				// if (this.ajaxContainer) this.ajaxContainer.classList.add('is-loading');
			},
			success: res => {
				this.form.classList.remove('is-loading');
				history.pushState(null, null, res.URL);
				if (this.ajaxContainer) {
					this.ajaxContainer.innerHTML = res.CONTENT || res.TEMPLATE;

					// Эта каша из Aspro
					setTimeout(function(){
						$('.catalog_block .catalog_item_wrapp .catalog_item .item-title').sliceHeight();
						$('.catalog_block .catalog_item_wrapp .catalog_item .cost').sliceHeight();
						$('.catalog_block .catalog_item_wrapp .item_info').sliceHeight();
						$('.catalog_block .catalog_item_wrapp').sliceHeight({classNull: '.footer_button'});
					}, 100)

					this.sortAndDisplay.forEach(container => {
						var pos = container.href.indexOf('&search=');
						if (pos != -1){
							var new_href = container.href.substring(0,pos);
							container.href = new_href + res.SEARCH;
						}else{
							container.href = container.href + res.SEARCH;
						}
					});

					this.ajaxContainer.classList.remove('is-loading');

					if (window.initFullProductCard) window.initFullProductCard();
					if (window.initCartButtons) window.initCartButtons();
				}

				// this.form.classList.remove('is-loading');
			}
		});
	}

	_resetBtnHandler() {
		if (!this.resetBtn) return false;

		this.resetBtn.addEventListener('click', e => {
			e.preventDefault();
			this.input.value = "";
			this.dirty = false;
			this._resetBtnsVisibility();
			this._sendRequest(this.form.dataset.resetAction || this.form.action);
		})
	}

	_checkFormDirty() {
		if (!this.input.value) {
			this.dirty = false;
		} else {
			this.dirty = true;
		}

		this._resetBtnsVisibility();
	}

	_resetBtnsVisibility() {
		if (!this.resetBtn) return false;

		if (this.dirty) {
			this.resetBtn.classList.remove('is-hidden');
		} else {
			this.resetBtn.classList.add('is-hidden');
		}
	}

	_inputHandler() {
		if (!this.input) return false;

		this.input.addEventListener('input', this._checkFormDirty.bind(this));

		if (this.type === "rent") {
			this.input.addEventListener('focus', () => {
				ym(27695811,'reachGoal','RENT_SEARCH');
			});
		}
	}
}
